<template>
    <div>
        <div class="table-wrapper on-575">
            <div class="custom-table table-theme2 wow fadeInUpBig" data-wow-duration="0.5" data-wow-delay="0.20s">
                <div class="trow head">
                    <div class="th" v-for="(head,index) in this.data.head" :key="index">{{head}}</div>
                </div>
                <div class="trow" v-for="(row,rindex) in this.data.rows" :key="rindex">
                    <div v-for="(col,colindex) in row" :key="colindex" v-html="col"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            data: Object
        }
    }
</script>

<style lang="scss" scoped>
.table-wrapper{
    /deep/{
        .custom-table {
            margin:rem(80px) 0;
            @media screen and (max-width:991px){
                margin:rem(50px) 0;
            }
            .trow{
                background:none;
                >div{
                    &:not(:first-child){
                        text-align:center;
                    }
                }
                &.head{
                    border-top:1px solid #000;
                    .th{
                        color:#4eb9e9;
                        font-weight:600;
                    }
                }
                &:not(.head){
                    >div{
                        &:nth-child(even){
                            background: rgba($color: #b6b8ba, $alpha: .5) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>